import { Component, Input } from '@angular/core';
import { MatChip } from '@angular/material/chips';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Trailer } from 'shared/types';

/**
 * @deprecated firefly-1-9758-ui will be removed after feature flag expires
 */
@Component({
  selector: 'app-trailer-details-popup-header',
  templateUrl: './trailer-details-popup-header.component.html',
  imports: [MatChip, NgIf, TranslateModule],
})
export class TrailerDetailsPopupHeaderComponent {
  @Input() public trailer!: Pick<Trailer, 'scacCode' | 'trailerNumber' | 'trailerType' | 'trailerStatus'>;
}
